// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"ad9d96a3","90":"7a7d3a49","131":"446f7592","143":"f468aa17","203":"c905a9d8","496":"c469760f","591":"f6d3c733","722":"59fe536d","856":"00696563","888":"024328d6","943":"75ec4cb8"}[chunkId] + ".chunk.js";
};